/**
@author: Nikhil 

jvCalendar
============
@desc: Used to show a bi-weekly/weekly calendar view.
@Usage : <div jv-week-calendar calendar-view="biweek" days-format=""></div>
@options:  
calendar-view : "biweek/week"
days-format  :  (default is defaultdays format)
 **/

angular.module('jv.Common.Directives.WeekCalendar', [])
.factory('configs', function() {
    return {
        formats: {
            defaultdays: {
                    '0': 'Su',
                    '1': 'Mo',
                    '2': 'Tu',
                    '3': 'We',
                    '4': 'Th',
                    '5': 'Fr',
                    '6': 'Sa'
            },
            shortdays: {
                    '0': 'Sun',
                    '1': 'Mon',
                    '2': 'Tue',
                    '3': 'Wed',
                    '4': 'Thu',
                    '5': 'Fri',
                    '6': 'Sat'
            },
            fulldays: {
                    '0': 'Sunday',
                    '1': 'Monday',
                    '2': 'Tuesday',
                    '3': 'Wednesday',
                    '4': 'Thursday',
                    '5': 'Friday',
                    '6': 'Saturday'
            },
            fullmonths : {
                    '0': 'January',
                    '1': 'February',
                    '2': 'March',
                    '3': 'April',
                    '4': 'May',
                    '5': 'June',
                    '6': 'July',
                    '7': 'August',
                    '8': 'September',
                    '9': 'October',
                    '10': 'November',
                    '11': 'December'
            },
            shortmonths : {
                    '0': 'Jan',
                    '1': 'Feb',
                    '2': 'Mar',
                    '3': 'Apr',
                    '4': 'May',
                    '5': 'Jun',
                    '6': 'Jul',
                    '7': 'Aug',
                    '8': 'Sep',
                    '9': 'Oct',
                    '10': 'Nov',
                    '11': 'Dec'
            }
        },
        viewMap: {
            week: 7,
            biweek: 14
        }
    };
})
.directive('jvWeekCalendar',['$timeout','configs',function($timeout, configs){
        var directiveDefinitionObject = {
            scope:{
                calendarView:'@',
                daysFormat:'@',
                monthsFormat:'@',
                dateClickCallback: '&',
                paginateCallback: '&',
                dates:'=',
                instanceId: '@'
            },
            replace: true,
            controller: function($scope, $element, $rootScope){
                switch($scope.daysFormat) {
                case "fulldays":
                    $scope.dayMap = configs.formats.fulldays;
                    break;
                case "shortdays":
                    $scope.dayMap = configs.formats.shortdays;
                    break;
                default:
                    $scope.dayMap = configs.formats.defaultdays;
                    break;
                }

                switch($scope.monthsFormat) {
                case "fullmonths":
                    $scope.monthMap = configs.formats.fullmonths;
                    break;
                case "shortmonths":
                    $scope.monthMap = configs.formats.shortmonths;
                    break;
                default:
                    $scope.monthMap = configs.formats.fullmonths;
                    break;
                }

                var detectMobile  = function(useragent) {
                    var mobileUserAgents, i;
                    mobileUserAgents = [
                        new RegExp('^(?=.*Android)(?=.*Mobile).*'),
                        new RegExp('.*iphone.*', 'i')
                    ];

                    for (i = mobileUserAgents.length - 1; i >= 0; i--) {
                        if (useragent.match(mobileUserAgents[i])) {
                            return true;
                        }
                    }
                    return false;
                };
                var userOnMobile  = detectMobile(window.navigator.userAgent);
                if(userOnMobile){
                    $scope.calendarView = 'week';
                }
                $scope.viewMap = configs.viewMap;
                $scope.dates  = [];

                var isCurrentDayToday = function(dateObj){
                    if(dateObj.toDateString() != $scope.today.toDateString()){
                        return false;
                    }
                    return true;
                };

                var contains  = function(item,arr){
                    var len = arr.length;
                    for(var i=0 ; i<len; i++){
                        if(arr[i] == item){
                            return true;
                        }
                    }
                return false;
                };
                var getNextdays = function(){
                    $scope.firstDate = $scope.lastDate;
                    $scope.monthsInView = [];
                    for (var i = 1; i <= $scope.viewMap[$scope.calendarView]; i++){
                        var today = $scope.lastDate;
                        var tomorrow = moment(today).add(i,'days')._d;
                        
                        if(! contains($scope.monthMap[tomorrow.getMonth()],$scope.monthsInView) ){
                            $scope.monthsInView.push($scope.monthMap[tomorrow.getMonth()]);
                        }
                        var fullDate = tomorrow.getFullYear()+'/'+(tomorrow.getMonth()+1)+'/'+tomorrow.getDate();
                        var dateObj = {
                            date: tomorrow.getDate(),
                            day: tomorrow.getDay(),
                            month: tomorrow.getMonth(),
                            year: tomorrow.getFullYear(),
                            fullDate: new Date(fullDate)
                        };
                        if( isCurrentDayToday(tomorrow) ){
                            dateObj.today = true;
                        }
                        $scope.dates.push(dateObj);
                        if(i === $scope.viewMap[$scope.calendarView] ){
                            $scope.firstDate = moment($scope.lastDate).add(1,'days')._d;
                            $scope.lastDate = tomorrow;
                        }
                    }
                };

                var getPrevDays = function(){
                    $scope.lastDate = $scope.firstDate;
                    $scope.monthsInView = [];
                    for (var i = 1; i <= $scope.viewMap[$scope.calendarView]; i++){
                        var today = $scope.lastDate;
                        var dayBefore = moment(today).subtract(i,'days')._d;
                        
                        if(! contains($scope.monthMap[dayBefore.getMonth()],$scope.monthsInView) ){
                            $scope.monthsInView.push($scope.monthMap[dayBefore.getMonth()]);
                        }
                        var fullDate = dayBefore.getFullYear()+'/'+(dayBefore.getMonth()+1)+'/'+dayBefore.getDate();
                        var dateObj = {
                            date: dayBefore.getDate(),
                            day: dayBefore.getDay(),
                            month: dayBefore.getMonth(),
                            year: dayBefore.getFullYear(),
                            fullDate: new Date(fullDate)
                        };
                        if( isCurrentDayToday(dayBefore) ){
                            dateObj.today = true;
                        }
                        $scope.dates.push(dateObj);
                        if(i === $scope.viewMap[$scope.calendarView]){
                            $scope.lastDate = moment($scope.firstDate).subtract(1,'days')._d;
                            $scope.firstDate = dayBefore;
                        }
                    }
                   
                };

                var findClosestSunday = function(dateObj,startDate){
                    var diff =  dateObj.day - 0;
                    startDate.setDate(startDate.getDate()-diff);
                    $scope.lastDate = new Date(startDate);
                };

                var setActiveDate = function(activeDate){
                    $scope.activeDate = activeDate;
                };

                //get todays date in user timezone
                var today = $rootScope.fetchTodayInUsersTimeZone();

                $scope.today = angular.copy(today);
                var todaysDate = $scope.today.getFullYear()+'/'+($scope.today.getMonth()+1)+'/'+$scope.today.getDate();
                var todaysDateObject = {
                    date: $scope.today.getDate(),
                    day: $scope.today.getDay(),
                    month: $scope.today.getMonth(),
                    year: $scope.today.getFullYear(),
                    fullDate: new Date(todaysDate)
                };
                //setting today as the active date on load
                setActiveDate(todaysDateObject);
                $scope.monthsInView = [];
                var fullDate = $scope.today.getFullYear()+'/'+($scope.today.getMonth()+1)+'/'+$scope.today.getDate();
                $scope.monthsInView.push($scope.monthMap[$scope.today.getMonth()]);
                
                var dateObj = {
                    date: $scope.today.getDate(),
                    day: $scope.today.getDay(),
                    month: $scope.today.getMonth(),
                    year: $scope.today.getFullYear(),
                    fullDate: new Date(fullDate)
                };
                findClosestSunday(dateObj,$scope.today);
                getNextdays();


                $scope.getNumber = function(num) {
                    return new Array(num);
                };
                
                $scope.dateClick = function(dateObj){
                    var data = {
                        dateObj:dateObj
                    };
                    setActiveDate(dateObj);
                    $scope.dateClickCallback(data);
                };

                $scope.paginateCalendar = function(direction){
                    if(userOnMobile){
                        $scope.calendarView = 'week';
                    }
                    $scope.dates = [];
                    if(direction == 'next'){
                        getNextdays();
                    }else{
                        getPrevDays();
                        $scope.dates = $scope.dates.reverse();
                        $scope.monthsInView = $scope.monthsInView.reverse();
                    }
                    var data = {
                        dates: $scope.dates
                    };
                    $scope.paginateCallback(data);
                };
            },
            templateUrl:jvUrls.source+'/htm/common/calendar.html'
        };
        return directiveDefinitionObject;
}]);
